import { ListaCotizaciones, Container } from "../../components";

export const ListadoCotizaciones = () => (
  <Container header titulo="Listado Cotizaciones">
    <ListaCotizaciones />
  </Container>
);
